if(!customElements.get('header-bar')) {
  class HeaderBar extends HTMLElement {
    static observedAttributes = ["menu-open", "cart-open", "search-open"];
  
    constructor() {
      super();
  
      this.menuOpen = this.getAttribute('menu-open') == 'true';
      this.cartOpen = this.getAttribute('cart-open') == 'true';
      this.searchOpen = this.getAttribute('search-open') == 'true';
  
      this.elMenu = this.querySelector('header-menu');
      this.elExpandedNav = this.querySelector('[data-expanded-nav]');
      this.elMenuToggles = this.querySelectorAll('[data-menu-toggle]');
      this.elCartDrawer = this.querySelector('cart-drawer');
      this.elCartToggles = this.querySelectorAll('[data-cart-toggle]');
  
      this.elMenuToggles.forEach(el => {
        el.addEventListener('click', this.openHeaderMenu.bind(this));
      });

      this.elCartToggles.forEach(el => {
        el.addEventListener('click', (ev) => {
          ev.preventDefault();
          window.toggleCart();
        });
      })
  
      this.setScrolledState();
    }
  
    openHeaderMenu() {
      let isOpen = this.elMenu.getAttribute('open') == 'true';
      this.menuOpen = !isOpen;

      this.setAttribute('menu-open', this.menuOpen);
      this.elMenu.setAttribute('open', this.menuOpen);
      this.elMenuToggles.forEach(el => {
        el.classList.toggle('active', this.menuOpen);
      })
    }
  
    setScrolledState() {
      const elObserver = this.parentNode.querySelector('[data-observer]');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(({ isIntersecting }) => {        
          isIntersecting ? this.classList.remove('scrolled') : this.classList.add('scrolled');
          if(this.elExpandedNav) {
            this.elExpandedNav.setAttribute('aria-hidden', !isIntersecting);
            this.elExpandedNav.setAttribute('tabindex', isIntersecting ? 0 : -1);
            isIntersecting ? this.elExpandedNav.classList.add('visible') : setTimeout(() => this.elExpandedNav.classList.remove('visible'), 300);
          }
        })
      });
  
      observer.observe(elObserver);
    }
  }
  
  customElements.define('header-bar', HeaderBar);
}

if(!customElements.get('header-menu')) {
  class HeaderMenu extends PopupModal {
    constructor() {
      super();
    }
  }

  customElements.define('header-menu', HeaderMenu);
}